import { useQuery } from '@tanstack/react-query';
import { publicApi } from '../api';

/** Heuristic: param that looks like a slug (lowercase, hyphens, no long random id) → fetch by slug. */
function looksLikeSlug(param: string): boolean {
  if (param.length < 2 || param.length > 80) return false;
  if (/^[a-zA-Z0-9_-]+$/.test(param) && param === param.toLowerCase() && param.length < 25) return true;
  return false;
}

/**
 * Hook to fetch public restaurant information.
 * No authentication required.
 * Supports both ID (e.g. k21nZtcAKvEc5RQTxwRQ) and slug (e.g. rasam) in the URL param.
 */
export const usePublicRestaurant = (restaurantIdOrSlug: string | undefined) => {
  const {
    data: restaurant,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['publicRestaurant', restaurantIdOrSlug],
    queryFn: () => {
      const param = restaurantIdOrSlug!;
      if (looksLikeSlug(param)) {
        return publicApi.getRestaurantBySlug(param);
      }
      return publicApi.getRestaurantById(param);
    },
    enabled: !!restaurantIdOrSlug,
  });

  return {
    restaurant,
    isLoading,
    isError,
    error,
  };
};

